import React, { useState } from 'react';



export const PostPlannerCard = ({ post, postDate, weekIndex, postIndex, onContentChange, onRegenerate, isRegenerating }) => {
  const [instructions, setInstructions] = useState('');
  const [showInstructions, setShowInstructions] = useState(false);

  return (
    <div className="post-planner-card" style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 1px 3px rgba(0,0,0,0.08)' }}>
      {/* Style tag to override external CSS with !important */}
      <style>
        {`
          .post-planner-date-badge-override {
            color: #ffffff !important;
            -webkit-text-fill-color: #ffffff !important;
          }
          .post-planner-card-footer button {
            max-height: 40px !important;
            min-height: 0 !important;
            height: auto !important;
          }
        `}
      </style>
      {/* Date badge */}
      <div className="post-planner-card-header" style={{ padding: '1rem 1.25rem', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderBottom: '1px solid #e5e7eb' }}>
        <span
          className="post-planner-date-badge-override"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: '0.75rem',
            fontWeight: '600',
            color: '#ffffff',
            background: 'linear-gradient(135deg, #156fb9 0%, #0f4f88 100%)',
            padding: '0.375rem 0.875rem',
            borderRadius: '6px',
            letterSpacing: '0.025em',
            boxShadow: '0 2px 4px rgba(21, 111, 185, 0.2)',
            textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
          }}>
          {postDate}
        </span>
      </div>

      {/* Title */}
      <div className="post-planner-card-section" style={{ padding: '1.25rem', borderBottom: '1px solid #f3f4f6' }}>
        <textarea
          id={`title-${weekIndex}-${postIndex}`}
          value={post.title}
          onChange={(e) => onContentChange(weekIndex, postIndex, 'title', e.target.value)}
          rows={1}
          placeholder="Post title..."
          className="post-planner-card-title"
          style={{ width: '100%', border: 'none', resize: 'none', fontSize: '1rem', fontWeight: '600', fontFamily: 'inherit', padding: 0 }}
        />
      </div>

      {/* Caption */}
      <div className="post-planner-card-section" style={{ padding: '1.25rem', borderBottom: 'none' }}>
        <textarea
          id={`caption-${weekIndex}-${postIndex}`}
          value={post.caption}
          onChange={(e) => onContentChange(weekIndex, postIndex, 'caption', e.target.value)}
          rows={5}
          placeholder="Post caption..."
          className="post-planner-card-caption"
          style={{ width: '100%', border: 'none', resize: 'vertical', fontSize: '0.875rem', color: '#4b5563', fontFamily: 'inherit', padding: 0, minHeight: '100px' }}
        />
      </div>

      {/* Special Instructions - Collapsible */}
      <div className="post-planner-card-footer" style={{ padding: '1rem 1.25rem', background: '#fafbfc', borderTop: '1px solid #e5e7eb', display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
        <button
          type="button"
          onClick={() => setShowInstructions(!showInstructions)}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.5rem',
            fontSize: '0.75rem',
            fontWeight: '600',
            color: '#6b7280',
            background: 'transparent',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}
        >
          <svg
            style={{
              width: '12px',
              height: '12px',
              transform: showInstructions ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s'
            }}
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            strokeWidth="2.5"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
          Special Instructions
        </button>

        {showInstructions && (
          <div className="post-planner-instructions-panel" style={{ paddingTop: '0.5rem' }}>
            <textarea
              id={`instructions-${weekIndex}-${postIndex}`}
              value={instructions}
              onChange={(e) => setInstructions(e.target.value)}
              rows={2}
              placeholder="e.g., Make this post funnier, add a question..."
              className="post-planner-instructions-input"
              style={{
                width: '100%',
                fontSize: '0.813rem',
                padding: '0.625rem',
                borderRadius: '6px',
                border: '1px solid #e5e7eb',
                resize: 'none',
                fontFamily: 'inherit'
              }}
            />
          </div>
        )}

        {/* Regenerate Button */}
        <button
          onClick={() => onRegenerate(weekIndex, postIndex, instructions)}
          disabled={isRegenerating}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '0.5rem',
            width: '100%',
            padding: '0.5rem 1rem',
            fontSize: '0.813rem',
            fontWeight: '600',
            color: '#fff',
            background: isRegenerating ? '#9ca3af' : 'linear-gradient(135deg, #156fb9 0%, #0f4f88 100%)',
            border: 'none',
            borderRadius: '8px',
            cursor: isRegenerating ? 'not-allowed' : 'pointer',
            boxShadow: '0 2px 4px rgba(21, 111, 185, 0.2)',
            transition: 'all 0.2s'
          }}
        >
          <svg style={{ width: '14px', height: '14px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
          {isRegenerating ? 'Regenerating...' : 'Regenerate Post'}
        </button>
      </div>
    </div>
  );
};
